// extracted by mini-css-extract-plugin
export default {"finalBanner":"FinalBanner_finalBanner__6JJfD"};